import React, { useMemo, useState } from "react"
import { cn } from "../../../../../lib"
import { Search, CalendarDays } from "lucide-react"
import { useSelector } from "react-redux"
import { selectAviaSearchDates } from "../../../../../app/reducers/book/aviaSearchSlice"
import { useTranslation } from "react-i18next"
import { formatFullDate } from "../../utils/date/common"
import { formatDateArray } from "../../utils/processing/search"

const DateModalBottomHead = ({ from, to, isDeparture }) => {
  const { t, i18n } = useTranslation()
  const locale = i18n.language
  const { round_trip } = useSelector(selectAviaSearchDates)

  //
  const [toQuery, setToQuery] = useState("")
  const [fromQuery, setFromQuery] = useState("")

  const displayDate = useMemo(() => {
    const fromArray = Array.isArray(from) ? from : []
    const toArray = Array.isArray(to) ? to : []

    return isDeparture ? formatDateArray(fromArray, locale) : formatDateArray(toArray, locale)
  }, [isDeparture, locale, from, to])

  return (
    <div className="px-6 py-4 bg-gray-50 ">
      <div className="flex gap-4 max-w-[340px]">
        {isDeparture ? (
          <div className="flex-1">
            <Label isDeparture={true}>{t("admin.departure_v2")}</Label>
            <div className="relative">
              <Input placeholder={t("admin.select_departure_date")} value={displayDate} />
            </div>
          </div>
        ) : (
          <div className="flex-1 relative">
            <div className="flex items-center justify-between">
              <Label>{t("admin.return_v2")}</Label>
              {!round_trip && (
                <button className="text-sm absolute right-0 -top-1 text-dark-red rounded-md bg-dark-red/15 p-0.5 font-medium hover:text-red-700">
                  - {t("admin.one_way_ticket_v3")} -
                </button>
              )}
            </div>
            <Input placeholder={t("admin.select_return_date")} value={displayDate} />
          </div>
        )}
      </div>
    </div>
  )
}

export default DateModalBottomHead

const Label = ({ children, isDeparture, className }) => {
  return <label className={cn("text-sm text-light-gray font-medium block ")}>{children}</label>
}

const Input = ({ value = "", placeholder, onChange, isFocus }) => {
  return (
    <div className="flex items-center gap-2 px-2 py-1 bg-gray-100 rounded border border-gray-300 hover:border-gray-400 focus-within:border-blue-500 transition-colors text-xs">
      <CalendarDays size={14} className={!value ? "text-light-gray/50" : "text-dark-green"} />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        readOnly={true}
        disabled={true}
        className="flex-1 bg-transparent text-xs text-dark-gray outline-none placeholder:text-light-gray placeholder:text-opacity-50"
      />
      <Search size={14} className="text-light-gray/50" />
    </div>
  )
}
